export default __webpack_public_path__ + "static/media/bikeibiza.bdab5dbd.jpg";